<script setup lang="ts">
import { computed } from 'vue'
import { micromark } from 'micromark'
import { releaseDetail } from '../releaseDetail'
import { type Account, TheTooltip } from '@wastedondestiny/destiny-library'

const props = withDefaults(defineProps<{
  dungeons: number[],
  account: Account,
  noInteract?: boolean
}>(), {
  noInteract: false
})

const owns = computed(() => props.account.dungeonsOwned?.find(x => props.dungeons.includes(x)))
const dungeonDescription = computed(() => micromark(releaseDetail.get(props.dungeons?.[0])?.shortDescription ?? ''))
</script>

<template>
  <div class="-mt-1 h-6 w-6 flex justify-center">
    <TheTooltip warning :no-interact="noInteract" v-if="account.private">
      <div class="mt-1.5 h-5 w-5 flex justify-center items-center rounded-xl bg-black opacity-25">
        <img src="../assets/unknown.svg" alt="Privacy Issue" class="h-4 w-4 invert" />
      </div>
      <template #icon>
        <img src="../assets/unknown.svg" alt="Privacy Issue" class="h-6 w-6" />
      </template>
      <template #content>
        <p>This user has their account settings private, preventing dungeons owned from showing up</p>
      </template>
    </TheTooltip>
    <TheTooltip :warning="!owns" :no-interact="noInteract" v-else>
      <div class="mt-1.5 h-5 w-5 flex justify-center items-center rounded-xl bg-black" :class="{ 'opacity-75': owns, 'opacity-25': !owns }">
        <img src="../assets/dungeon.png" alt="Dungeon Key" class="h-4 w-4 invert" />
      </div>
      <template #icon>
        <img src="../assets/dungeon.png" alt="Dungeon Key" class="h-6 w-6" />
      </template>
      <template #content>
        <p>This user {{ owns ? 'owns' : 'does not own' }} this dungeon key</p>
        <div class="markdown" v-html="dungeonDescription" />
      </template>
    </TheTooltip>
  </div>
</template>
